import { render, staticRenderFns } from "./InsectPestDetail.vue?vue&type=template&id=6ba717b8&scoped=true&"
import script from "./InsectPestDetail.vue?vue&type=script&lang=ts&"
export * from "./InsectPestDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InsectPestDetail.vue?vue&type=style&index=0&id=6ba717b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba717b8",
  null
  
)

export default component.exports